export const getRovingTabIndex = (isActive, isFirst, hasActive) => {
  if (hasActive) {
    return isActive ? 0 : -1;
  }
  return isFirst ? 0 : -1;
};
